module.exports = __webpack_public_path__ + "img/dhfesta_productInfo_0415.29bcbb60.png";